import { DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

import { Popover } from 'antd';

import MultiSelect from '@/components/shared/MultiSelect/MultiSelect';
import { SessionStatus } from '@/lib/types/session-status';
import { getDateLabel } from '@/lib/utils/date-time';
import { getDefaultCoaches } from '@/pages/Admin/Sessions/utils/utils';
import { Coach } from '@addmile/backend-client';

import { StatusSelect } from '../../StatusSelect/StatusSelect';
import Button from '../../shared/Button/Button';
import { DateRangePicker } from '../DaterangePicker/DaterangePicker';
import { statusOptions } from '../data';

export interface ExternalFilters {
  externalFilter?: { coachIds?: string[]; dateRange: DateRange };
  setExternalFilter?: (filter: { coachIds?: string[]; dateRange?: DateRange }) => void;
  externalFilterData?: {
    coaches?: Coach[];
  };
}

interface FiltersProps extends ExternalFilters {
  statusFilter: SessionStatus;
  setStatusFilter: (status: SessionStatus | null) => void;
}

const Filters = ({
  statusFilter,
  setStatusFilter,
  externalFilter,
  setExternalFilter,
  externalFilterData,
}: FiltersProps) => {
  const clearFilters = () => {
    setStatusFilter(null);

    if (setExternalFilter)
      setExternalFilter({
        coachIds: getDefaultCoaches(externalFilterData?.coaches || []),
        dateRange: { from: undefined, to: undefined },
      });
  };
  return (
    <div className="mb-4 flex items-center gap-4">
      <div className="flex items-center gap-4">
        <label htmlFor="statusFilter" className="font-semibold">
          Status:
        </label>
        <StatusSelect
          status={statusFilter || ''}
          onChange={(status) => setStatusFilter(status || null)}
          options={statusOptions}
        />
      </div>
      {externalFilter?.dateRange && setExternalFilter && (
        <div className="flex items-center gap-4">
          <label htmlFor="statusFilter" className="font-semibold">
            Date:
          </label>
          <Popover
            content={
              <DateRangePicker
                selected={externalFilter.dateRange}
                setSelected={setExternalFilter}
              />
            }
            trigger="click"
          >
            <Button
              type="button"
              className="!h-[32px] w-[110px] !font-medium !border-neutral-30 py-1 px-2 justify-start"
              label={getDateLabel(externalFilter.dateRange)}
              size="s"
              variant="transparent"
            />
          </Popover>
        </div>
      )}
      {externalFilterData?.coaches?.length && (
        <div className="flex items-center gap-4">
          <label htmlFor="statusFilter" className="font-semibold">
            Coach:
          </label>
          <MultiSelect
            value={externalFilter?.coachIds ?? []}
            onChange={(coachIds: string[]) => {
              if (setExternalFilter) setExternalFilter({ coachIds });
            }}
            options={externalFilterData?.coaches?.map((coach) => ({
              value: coach.id,
              label: coach.name,
            }))}
            placeholder="Coaches"
          />
        </div>
      )}

      <Button
        type="button"
        label="Clear Filters"
        size="xs"
        variant="transparent"
        onClick={clearFilters}
      />
    </div>
  );
};

export default Filters;
